import React, { useEffect, useState } from "react";
import { Avatar, Box, Grid, Paper, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import { Rating } from "@mui/material";
import moment from "moment";
import api from "../../../../config/api";

const ProductReviewCard = ({ item }) => {
  const [value, setValue] = useState(item?.ratings || 0);
  const date = moment(item.createdAt).format("L");
  const { productId } = useParams();
  const [latestRating, setLatestRating] = useState(null); 

  useEffect(() => {
    const fetchProductRatings = async () => {
      try {
        const response = await api.get(`/api/ratings/product/${productId}`);
        const ratings = response.data;

        if (ratings.length > 0) {
          const sortedRatings = ratings.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
          setLatestRating(sortedRatings[0]); 
          setValue(sortedRatings[0].rating); 
        } else {
          setLatestRating(null); 
        }
      } catch (error) {
        console.error("Error fetching product ratings", error);
      }
    };

    fetchProductRatings();
  }, [productId]);
  const handleRatingChange = async (event, newValue) => {
    setValue(newValue); 
    try {
      await api.put(`/api/reviews/${item.id}/rating`, {
        rating: newValue,
      });
      const response = await api.get(`/api/ratings/product/${productId}`);
      const ratings = response.data;

      if (ratings.length > 0) {
        const sortedRatings = ratings.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setLatestRating(sortedRatings[0]); 
        setValue(sortedRatings[0].rating); 
      } else {
        setLatestRating(null); 
      }
    } catch (error) {
      console.error("Error updating rating:", error);
    }
  };

  return (
    <Paper elevation={3} style={{ padding: "16px", borderRadius: "8px", marginBottom: "10px"  }}>
      <Grid container spacing={2}>
        <Grid item xs={3} sm={2} md={1} display="flex" justifyContent="center" alignItems="center">
          <Avatar
            sx={{ width: 50, height: 50, bgcolor: "#9155FD", margin:"10px" }}
            alt={item?.user?.firstName}
          >
            {item?.user?.firstName ? item.user.firstName[0].toUpperCase() : "?"}
          </Avatar>
        </Grid>
        <Grid item xs={9} sm={10} md={11}>
          <Box display="flex" flexDirection="column" justifyContent="space-between" height="100%">
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
              <Typography variant="h6" className="font-semibold">
                {item.user?.firstName}
              </Typography>
              <Typography variant="body2" className="opacity-70">
                {date}
              </Typography>
            </Box>
            {/* Display only the latest rating */}
            {latestRating ? (
              <Box display="flex"  alignItems="center" mb={1}>
                {/* <Typography variant="body2" className="opacity-70">
                  <span className="text-lg font-serif">Rating:</span> {latestRating.rating}
                </Typography> */}
                <Rating
                  value={value}
                  onChange={handleRatingChange}
                  name="rating"
                  precision={0.5}
                />
              </Box>
            ) : (
              <Typography variant="body2" className="text-sm text-gray-600">
                No ratings available
              </Typography>
            )}
            <Typography variant="body1">
              {item?.review}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ProductReviewCard;









































































































































































































































































// import React, { useEffect, useState } from "react";
// import { Avatar, Box, Grid, Paper, Typography } from "@mui/material";
// import { useParams } from "react-router-dom";
// import { Rating } from "@mui/material";
// import moment from "moment";
// import api from "../../../../config/api";

// const ProductReviewCard = ({ item }) => {
//   const [value, setValue] = useState(item?.ratings || 0);
//   const date = moment(item.createdAt).format("L");
//   const { productId } = useParams();
//   const [latestRating, setLatestRating] = useState(null); 

//   useEffect(() => {
//     const fetchProductRatings = async () => {
//       try {
//         const response = await api.get(`/api/ratings/product/${productId}`);
//         const ratings = response.data;

//         if (ratings.length > 0) {
//           const sortedRatings = ratings.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
//           setLatestRating(sortedRatings[0]); 
//           setValue(sortedRatings[0].rating); 
//         } else {
//           setLatestRating(null); 
//         }
//       } catch (error) {
//         console.error("Error fetching product ratings", error);
//       }
//     };

//     fetchProductRatings();
//   }, [productId]);
//   const handleRatingChange = async (event, newValue) => {
//     setValue(newValue); 
//     try {
//       await api.put(`/api/reviews/${item.id}/rating`, {
//         rating: newValue,
//       });
//       const response = await api.get(`/api/ratings/product/${productId}`);
//       const ratings = response.data;

//       if (ratings.length > 0) {
//         const sortedRatings = ratings.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
//         setLatestRating(sortedRatings[0]); 
//         setValue(sortedRatings[0].rating); 
//       } else {
//         setLatestRating(null); 
//       }
//     } catch (error) {
//       console.error("Error updating rating:", error);
//     }
//   };

//   return (
//     <Paper elevation={3} style={{ padding: "16px", borderRadius: "8px", marginBottom: "10px"  }}>
//       <Grid container spacing={2}>
//         <Grid item xs={3} sm={2} md={1} display="flex" justifyContent="center" alignItems="center">
//           <Avatar
//             sx={{ width: 50, height: 50, bgcolor: "#9155FD", margin:"10px" }}
//             alt={item?.user?.firstName}
//           >
//             {item?.user?.firstName ? item.user.firstName[0].toUpperCase() : "?"}
//           </Avatar>
//         </Grid>
//         <Grid item xs={9} sm={10} md={11}>
//           <Box display="flex" flexDirection="column" justifyContent="space-between" height="100%">
//             <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
//               <Typography variant="h6" className="font-semibold">
//                 {item.user?.firstName}
//               </Typography>
//               <Typography variant="body2" className="opacity-70">
//                 {date}
//               </Typography>
//             </Box>
//             {/* Display only the latest rating */}
//             {latestRating ? (
//               <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
//                 <Typography variant="body2" className="opacity-70">
//                   <span className="text-lg font-serif">Rating:</span> {latestRating.rating}
//                 </Typography>
//                 <Rating
//                   value={value}
//                   onChange={handleRatingChange}
//                   name="rating"
//                   precision={0.5}
//                 />
//               </Box>
//             ) : (
//               <Typography variant="body2" className="text-sm text-gray-600">
//                 No ratings available
//               </Typography>
//             )}
//             <Typography variant="body1">
//               {item?.review}
//             </Typography>
//           </Box>
//         </Grid>
//       </Grid>
//     </Paper>
//   );
// };

// export default ProductReviewCard;
